import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const MONTHS = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];

export const periodRange = (p, year) => {
  const now = new Date();
  if (p === "all") { return { params: {}, label: "Tutto" }; }
  if (p === "year") { return { params: { date_from: `${year}-01-01`, date_to: `${year}-12-31` }, label: `Anno ${year}` }; }
  const s = new Date(now.getFullYear(), now.getMonth() - (p === "prev" ? 1 : 0), 1);
  return { params: { date_from: iso(s), date_to: iso(new Date(s.getFullYear(), s.getMonth() + 1, 0)) }, label: `${MONTHS[s.getMonth()]} ${s.getFullYear()}` };
};

export const usePeriod = (initial = "month") => {
  const [period, setPeriod] = useState(initial);
  const [year, setYear] = useState(new Date().getFullYear());
  const range = periodRange(period, year);
  return { period, setPeriod, year, setYear, range, rangeKey: JSON.stringify(range.params) };
};

export const PeriodPicker = ({ period, setPeriod, year, setYear, testId = "invoices" }) => {
  const cur = new Date().getFullYear();
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2" data-testid={`${testId}-period`}>
      {[["month", "Mese corrente"], ["prev", "Mese precedente"], ["year", "Anno intero"], ["all", "Tutto"]].map(([k, l]) => (
        <Button key={k} size="sm" variant={period === k ? "secondary" : "ghost"} className="rounded-full" onClick={() => setPeriod(k)} data-testid={`${testId}-period-${k}`}>{l}</Button>))}
      {period === "year" && <div className="flex items-center gap-1">
        <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => setYear(year - 1)} data-testid={`${testId}-year-prev`}><ChevronLeft className="h-4 w-4" /></Button>
        <span className="w-12 text-center text-sm font-semibold text-ink" data-testid={`${testId}-year`}>{year}</span>
        <Button size="icon" variant="ghost" className="h-8 w-8" disabled={year >= cur} onClick={() => setYear(year + 1)} data-testid={`${testId}-year-next`}><ChevronRight className="h-4 w-4" /></Button>
      </div>}
    </div>
  );
};
